import React from "react";

import Cta from "../../Cta";

export default ({ className, text, url }) => (
  <Cta text={text} url={url} theme={className || "light"} />
);



// WEBPACK FOOTER //
// /Users/pauloamgomes/Sites/CockpitReactStatic/react-app/src/components/cockpit/Button/Button.js